import {EntryInput} from "@library/domain/recruit/EntryField";
import {ValidateEntryUseCase} from "@library/usecase/recruit/ValidateEntryUseCase";
import {EntryErrorMessagePresenter} from "@library/interface_adapter/recruit/EntryErrorMessagePresenter";

/**
 * 採用エントリーのフォームの状態（入力値と、その検証結果のメッセージ）。
 */
export class EntryFormModel {
    readonly #validate_entry_use_case: ValidateEntryUseCase;
    readonly #error_message_presenter: EntryErrorMessagePresenter;

    #error_messages: string[] = [];

    public constructor(
        validate_entry_use_case: ValidateEntryUseCase = new ValidateEntryUseCase(),
        error_message_presenter: EntryErrorMessagePresenter = new EntryErrorMessagePresenter()
    ) {
        this.#validate_entry_use_case = validate_entry_use_case;
        this.#error_message_presenter = error_message_presenter;
    }

    public get errorMessages(): readonly string[] {
        return this.#error_messages;
    }

    public get isValid(): boolean {
        return this.#error_messages.length === 0;
    }

    /**
     * 入力値を検証し、エラーのメッセージを更新する
     */
    public update(input: EntryInput): void {
        this.#error_messages = this.#error_message_presenter.present(this.#validate_entry_use_case.execute(input));
    }
}
